import { useEffect, useState } from 'react'
import ParticipantAndDetails from './ParticipantAndDetails'
import { Avatar, Input, Radio, RadioChangeEvent, Select } from 'antd'
import { convertToUtc, getNameSignature } from 'helper/utility'
import { Person } from 'types/globalTypes'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import {
  CheckinOutAttendeeWithType,
  CheckinPayload,
  CheckoutPayload,
  PickUpDetailsType,
} from 'types/event/eventAttendance'
import { useGetFamilyMembers } from 'api/family/family'
import { failureMessage } from 'api/global'
import Spinner from 'components/Spinner'
import { eventDetailsStore } from 'state/event/eventDetails'
import { EventResp } from 'types/event/events'
import {
  useCheckInParticipantDirectly,
  useCheckoutEventRequest,
} from 'api/Event/Attendance'
import ButtonSpinner from 'components/global/ButtonSpinner'
import SomeOneElse from './SomeOneElse'
import {
  useDropInEvents,
  useDropOutFromEvnet,
  useGetDropInAttendeeDetails,
} from 'api/Event/Dropin'
import { useParams } from 'react-router-dom'
import CheckoutFromDeviceModal from '../DetailedCheckout/CheckoutFromDeviceModal'

interface CheckInOutTabProps {
  type: 'check-in' | 'check-out' | 'drop-out' | 'drop-in'
}

const CheckInOutTab = ({ type }: CheckInOutTabProps) => {
  const { id }: { id: string } = useParams()
  const [selectedValue, setSelectedValue] = useState<string | undefined>(
    'guardian',
  )
  const [selectedAdult, setSelectedAdult] = useState<string>()
  const [someOneElse, setSomeoneElse] = useState<PickUpDetailsType>({
    name: '',
    email: '',
    phone: {
      dialCode: '',
      isoCode: '',
      number: '',
    },
    photoId: '',
  })

  const [notes, setNotes] = useState<string>()
  const {
    participantData,
    setParticipantData,
    setCheckInModalOpen,
    setCheckInOutModalOpen,
    setCheckOutModalOpen,
    dropInPricing,
    setDetailedDropInModalOpen,
    setDetailedDropOutModalOpen,
    checkOutFromThisDeviceModalOpen,
    setCheckOutFromThisDeviceModalOpen,
  }: {
    participantData:
      | (CheckinOutAttendeeWithType & { role: 'kid' | 'adult' | 'guardian' })
      | null
    setParticipantData: (attendee: CheckinOutAttendeeWithType) => void | null
    setCheckInModalOpen: (value: boolean) => void
    setCheckInOutModalOpen: (value: boolean) => void
    setCheckOutModalOpen: (value: boolean) => void
    dropInPricing: number
    setDetailedDropInModalOpen: (value: boolean) => void
    setDetailedDropOutModalOpen: (value: boolean) => void
    checkOutFromThisDeviceModalOpen: boolean
    setCheckOutFromThisDeviceModalOpen: (value: boolean) => void
  } = eventAttendanceStore(store => ({
    participantData: store.participantData,
    setParticipantData: store.setParticipantData,
    setCheckInModalOpen: store.setCheckInModalOpen,
    setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    setCheckOutModalOpen: store.setCheckOutModalOpen,
    dropInPricing: store.dropInPricing,
    setDetailedDropInModalOpen: store.setDetailedDropInModalOpen,
    setDetailedDropOutModalOpen: store.setDetailedDropOutModalOpen,
    checkOutFromThisDeviceModalOpen: store.checkOutFromThisDeviceModalOpen,
    setCheckOutFromThisDeviceModalOpen:
      store.setCheckOutFromThisDeviceModalOpen,
  }))
  const { eventDetailedData }: { eventDetailedData: EventResp } =
    eventDetailsStore(store => ({
      eventDetailedData: store.eventDetailedData,
    }))

  const params = {
    memberId: participantData._id,
    date: convertToUtc(new Date()),
    checkInId: participantData.checkInId,
  }

  // const {
  //   data: dropInAttendeeDetail,
  //   isLoading: isDropInAttendeeDetailLoading,
  //   isFetching: isDropInAttendeeDetailFetching,
  //   refetch: refetchDropInAttendeeDetail,
  // } = useGetDropInAttendeeDetails(id, params)
  const handleRadioChange = (val: RadioChangeEvent) => {
    console.log('changed', val)
    setSelectedValue(val.target.value)
  }

  const {
    data: familyMembers,
    isLoading: familyMembersLoading,
    isFetching: familyMembersFetching,
    refetch: familyMembersRefetch,
  } = useGetFamilyMembers(participantData.familyId)

  const {
    mutate: checkInParticipantMutation,
    isLoading: checkInParticipantLoading,
  } = useCheckInParticipantDirectly()
  const {
    mutate: checkoutEventRequest,
    isLoading: checkoutEventRequestLoading,
  } = useCheckoutEventRequest()
  const { mutate: dropOutMutation, isLoading: dropOutMutationLoading } =
    useDropOutFromEvnet()
  const {
    mutate: dropInToEventMutation,
    isLoading: dropIntpEventMutationLoading,
  } = useDropInEvents()

  const handleCheckIn = () => {
    if (type === 'drop-in') {
      const payload = {
        eventId: eventDetailedData._id,
        dropIn: true,
        [`${participantData.role || participantData.type}Id`]:
          participantData._id,
        familyId: participantData.familyId,
      }
      dropInToEventMutation(payload, {
        onSuccess: () => {
          setCheckInOutModalOpen(true)
          setDetailedDropInModalOpen(false)
        },
      })
      return
    }

    let payload = {
      eventId: eventDetailedData._id,
      [`${participantData.type}Id`]: participantData._id,
      familyId: participantData.familyId,
    }

    if (selectedValue === 'guardian') {
      payload = {
        ...payload,
        pickUpGuardianId: participantData.guardianId,
        pickUpPerson: 'guardian',
      }
    }

    if (selectedValue === 'adult') {
      if (!selectedAdult) return failureMessage('Select an adult')
      payload = {
        ...payload,
        pickUpPerson: 'authorized-adult',
        pickUpAdultId: selectedAdult,
      }
    }

    if (selectedValue === 'someone-else') {
      if (!someOneElse.name) return failureMessage('Enter name')
      if (someOneElse.phone.number.length < 4)
        return failureMessage('Enter valid phone number')
      if (!someOneElse.photoId) return failureMessage('Photo is required')
      payload = {
        ...payload,
        pickUpPerson: 'someone-else',
        pickUpPersonDetails: {
          name: someOneElse.name,
          phone: someOneElse.phone,
          email: someOneElse.email ? someOneElse.email : undefined,
          photoId: someOneElse.photoId ? someOneElse.photoId : undefined,
        } as any,
      }
    }

    if (type === 'check-out') {
      payload = {
        ...payload,
        checkOutNotes: notes ? notes : undefined,
        checkInId: participantData.checkInId,
      }
    } else if (type === 'drop-out') {
      delete payload.eventId
      payload = {
        ...payload,
        date: convertToUtc(new Date()),
        // amountToChargeForDropIn:
        //   dropInPricing || dropInAttendeeDetail.cost.amount,
        checkInId: participantData.checkInId,
      } as any
    } else {
      payload = {
        ...payload,
        checkInNotes: notes ? notes : undefined,
        // admissionTicket: participantData.admissionTicket,
        admissionTicket: participantData.ticket,
      } as any
    }

    if (type === 'check-out') {
      checkoutEventRequest(payload as CheckoutPayload, {
        onSuccess: () => {
          setCheckInOutModalOpen(true)
          setCheckOutModalOpen(false)
        },
      })
    } else if (type === 'drop-out') {
      dropOutMutation(payload as any, {
        onSuccess: () => {
          setDetailedDropOutModalOpen(false)
          setCheckInOutModalOpen(true)
        },
      })
    } else {
      checkInParticipantMutation(payload as CheckinPayload, {
        onSuccess: () => {
          setCheckInOutModalOpen(true)
          setCheckInModalOpen(false)
        },
      })
    }
  }

  const hanldeCheckOutFromThisDevice = () => {
    setCheckOutFromThisDeviceModalOpen(true)
  }

  useEffect(() => {
    if (participantData?.familyId) {
      familyMembersRefetch()
    }
  }, [participantData.familyId])

  // useEffect(() => {
  //   if (type === 'drop-out') {
  //     refetchDropInAttendeeDetail()
  //   }
  // }, [])

  // if (
  //   (isDropInAttendeeDetailFetching || isDropInAttendeeDetailLoading) &&
  //   type === 'drop-out'
  // ) {
  //   return (
  //     <div className="py-40px flex align-center justify-center">
  //       <Spinner />
  //     </div>
  //   )
  // }

  return (
    <>
      <div className="flex gap-20px">
        <div className="flex-1 relative" style={{ minHeight: '35rem' }}>
          {participantData.type === 'kid' && participantData.familyId ? (
            <div className="pt-20px">
              <h3 className="text-14 w-600">
                {type === 'check-in'
                  ? 'Who will pick up?'
                  : 'Who is picking up?'}
              </h3>

              <Radio.Group
                onChange={handleRadioChange}
                defaultValue={selectedValue}
              >
                <div className="mt-20px radius-12 border-1px py-20px px-20px">
                  <div>
                    <Radio value={'guardian'} className="radio">
                      Guardian
                    </Radio>
                  </div>
                </div>
                <div className="mt-20px radius-12 border-1px py-20px px-20px">
                  <div>
                    <Radio value={'adult'} className="radio">
                      Authorized Adults
                    </Radio>
                  </div>
                  {selectedValue === 'adult' && (
                    <>
                      <label className="input-label text-16 mt-20px">
                        Select Authorized Adult
                      </label>
                      <div>
                        <Select
                          className="h-50px  w-full"
                          placeholder={'Select color'}
                          defaultValue={undefined}
                          onChange={(
                            v,
                            item: { value: string; key: string },
                          ) => {
                            setSelectedAdult(item.value)
                          }}
                        >
                          {familyMembersLoading || familyMembersFetching ? (
                            <div className="flex justify-center py-10px">
                              <Spinner />
                            </div>
                          ) : familyMembers.adults.length ? (
                            familyMembers.adults.map((adult: Person) => {
                              return (
                                <Select.Option
                                  key={adult._id}
                                  value={adult._id}
                                >
                                  <div className="flex align-center gap-16px mt-10px">
                                    <Avatar size={30} src={adult.photo?.post}>
                                      {getNameSignature(
                                        `${adult.firstName} ${adult.lastName}`,
                                      )}
                                    </Avatar>
                                    <p>{`${adult.firstName} ${adult.lastName}`}</p>
                                  </div>
                                </Select.Option>
                              )
                            })
                          ) : (
                            <div className="py-10px">
                              <p>No adults found for this family </p>
                            </div>
                          )}
                        </Select>
                      </div>
                    </>
                  )}
                </div>
                <div className="mt-20px radius-12 border-1px py-20px px-20px">
                  <div>
                    <Radio value={'someone-else'} className="radio">
                      Someone else
                    </Radio>
                  </div>
                  {selectedValue === 'someone-else' && (
                    <SomeOneElse
                      formValues={someOneElse}
                      setFormValues={setSomeoneElse}
                    />
                  )}
                </div>
              </Radio.Group>
            </div>
          ) : (
            <div style={{ maxWidth: '400px' }}>
              <label className="input-label text-16 mt-20px">Notes</label>
              <Input
                name="notes"
                className="custom-input-field w-full"
                placeholder="Add a note"
                onChange={e => setNotes(e.target.value)}
              />
            </div>
          )}
          <div className="flex gap-20px flex-col w-40p">
            <button className="btn-prim mt-20px" onClick={handleCheckIn}>
              {checkInParticipantLoading ||
              checkoutEventRequestLoading ||
              dropOutMutationLoading ||
              dropIntpEventMutationLoading ? (
                <ButtonSpinner size={20} color="#000" />
              ) : type === 'check-out' ? (
                'Request Check-out'
              ) : type === 'drop-out' ? (
                'Drop-out'
              ) : type === 'drop-in' ? (
                'Drop-in'
              ) : (
                'Check-in'
              )}
            </button>
            {type === 'check-out' && (
              <button
                className="btn-prim"
                onClick={hanldeCheckOutFromThisDevice}
              >
                Check-out from this device
              </button>
            )}
          </div>
        </div>
        {participantData.familyId ? (
          <div className="bg-dark-gray px-30px py-20px">
            <ParticipantAndDetails type={type} />
          </div>
        ) : null}
      </div>

      {checkOutFromThisDeviceModalOpen && (
        <CheckoutFromDeviceModal
          eventId={eventDetailedData._id}
          familyId={participantData.familyId}
          checkOutNotes={notes}
          checkInId={participantData.checkInId}
          participanType={participantData.type}
          participantId={participantData._id}
          pickUpPerson={selectedValue}
        />
      )}
    </>
  )
}

export default CheckInOutTab
